import platform from 'platform';

export const isiOS15Safari = () => {
  const UA = navigator.userAgent;
  // converts versions like 4.3.3 to numeric value 4.33 for ease of numeric comparisons
  const OS = /OS (\d)?\d_\d(_\d)?/i.exec(UA);
  const OSVersion = OS && OS[0].replace('_', '.').replace('_', '').replace('OS ', '');
  const isOS15Version = OSVersion && OSVersion >= 15 && OSVersion < 16;
  return /\b(iPad|iPhone|iPod)\b/.test(UA) && /WebKit/.test(UA) && !/CriOS/.test(UA) && isOS15Version;
};

export const isSafari = () => {
  const UA = navigator.userAgent;
  return /\b(iPad|iPhone|iPod|Macintosh)\b/.test(UA) && /WebKit/.test(UA) && !/CriOS|Chrome/.test(UA);
};

export const isAndroid = () => {
  const UA = navigator.userAgent;
  return /Android/.test(UA);
};

export const isIOS = () => {
  const UA = navigator.userAgent;
  return /\b(iPad|iPhone|iPod)\b/.test(UA);
};

export const getUserAgent = () => {
  return navigator.userAgent;
};

export const getBrowserVersion = () => {
  return `${platform.name} ${platform.version}`;
};

export const getOS = () => {
  return `${platform.os.family} ${platform.os.version}`;
};
